import { Component, Inject } from '@angular/core'
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from '@angular/forms'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'

@Component({
    selector: 'aio-save-dialog',
    templateUrl: './save.component.html',
    styleUrls: ['./save.component.sass'],
    standalone: false
})
export class SaveDialogComponent {
  public form: UntypedFormGroup

  constructor(
    public dialogRef: MatDialogRef<SaveDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public types: string[],
    private formBuilder: UntypedFormBuilder
  ) {
    this.form = this.formBuilder.group({
      type: this.formBuilder.control('', Validators.required),
      label: this.formBuilder.control('', Validators.required)
    })
  }

  save() {
    if (this.form.valid) {
      this.dialogRef.close(this.form.value)
    }
  }
}
